
//=============================================================================
// Contents   : HRDB
//              社員一覧-出向(出)
//              GetAssignedList
// Author     : RV小寺
// LastUpdate : 2023/3/28
// Since      : 2022/12/8
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";
import { useNavigate } from 'react-router-dom';
/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */

/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */


/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */  

/* ========= テーブルデータ ========= */

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 一覧テンプレート ========= */
export const GetAssignedList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

   /* ====== テーブルリストを押した時の処理 ====== */
   const onClickBodyRow = (event,row) => {
    event.preventDefault();
    navigate('/employee/information/detail',{state:{empNmb:row.empNmb}})
    };
 
    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'sarLiteral' , base64:true}
        ],
        payload:[
            {name:'empNmb',                     base64:false},
            {name:'empFullName',                base64:true},
            {name:'entryDate',                  base64:false},
            {name:'secSrtDate',                 base64:false},
            {name:'rtnDate',                    base64:false},
            {name:'secDestnCmpCd',              base64:false},
            {name:'secDestnCmpName',            base64:true},
            {name:'secDestnDpt',                base64:true},
            {name:'cstBrd',                     base64:false},
            {name:'bfSecAfiDptCd',              base64:false},
            {name:'bfSecAfiDptName',            base64:true},
            {name:'secAsiInfoRema',             base64:true},
            {name:'crntSecTermSrtDate',         base64:false},
            {name:'crntSecTermEndDate',         base64:false},
            {name:'bfSecTermSrtDate',           base64:false},
            {name:'bfSecTermEndDate',           base64:false},
            {name:'lastUdr',                    base64:true},
            {name:'lastUpDate',                 base64:false},
            {name:'rtnSttFlag',                 base64:false},
        ]              
    };
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'empNmb', align: 'left', width: '120px', sortTable:true, label1: '従業員番号' ,fixed:true,left:'0px'},
    	{ id: 'empFullName', align: 'left', width: '120px', sortTable:true, label1:'氏名',fixed:true,left:'125px' ,borderRight:'1px solid #c0c0c0'},
        { id: 'entryDate', align: 'left', width: '120px', sortTable:true, label1: '入社日', label2: '(開始日)'},
    	{ id: 'secSrtDate', align: 'left', width: '120px', sortTable:true, label1: '出向開始日' },
    	{ id: 'rtnDate', align: 'left', width: '100px', sortTable:true, label1: '帰任日' },
        { id: 'secDestnCmpCd', align: 'left', width: '120px', sortTable:true, label1: '出向先',label2: '会社コード' },
        { id: 'secDestnCmpName', align: 'left', width: '215px', sortTable:true, label1: '出向先会社' },
        { id: 'secDestnDpt', align: 'left', width: '250px', sortTable:true, label1: '出向先部署' },
        { id: 'cstBrd', align: 'left', width: '170px', sortTable:true, label1: '費用負担', label2: '（TC：出向先）' },
        { id: 'bfSecAfiDptCd', align: 'left', width: '130px', sortTable:true, label1: '出向前所属部署コード'  },
        { id: 'bfSecAfiDptName', align: 'left', width: '250px', sortTable:true, label1: '出向前所属部署'  },
        { id: 'secAsiInfoRema', align: 'left', width: '100px', sortTable:true, label1: '備考' },//幅について要確認
        { id: 'crntSecTermSrtDate', align: 'left', width: '120px', sortTable:true, label1: '現出向期間',label2: '開始日' },
        { id: 'crntSecTermEndDate', align: 'left', width: '120px', sortTable:true, label1: '現出向期間',label2: '終了日' },
        { id: 'bfSecTermSrtDate', align: 'left', width: '150px', sortTable:true, label1: '前回出向期間' ,label2: '開始日' },
        { id: 'bfSecTermEndDate', align: 'left', width: '150px', sortTable:true, label1: '前回出向期間' ,label2: '終了日'  },
        { id: 'lastUdr', align: 'left', width: '120px', sortTable:true, label1: '最終更新者' },
        { id: 'lastUpDate', align: 'left', width: '120px', sortTable:true, label1: '最終更新日' },
        

    ];

    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'empNmb', type: 'label',  align: 'left',fixed:true,left:'0px'},
        { name: 'empFullName', type: 'label',  align: 'left',fixed:true,left:'125px', borderRight:'1px solid #c0c0c0' },
        { name: 'entryDate', type: 'dateLabel',  align: 'left',borderRight:'1px solid #c0c0c0'},
        { name: 'secSrtDate', type: 'dateLabel',  align: 'left'},
        { name: 'rtnDate', type: 'dateLabel',  align: 'left'},
        { name: 'secDestnCmpCd', type: 'label',  align: 'left'},
        { name: 'secDestnCmpName', type: 'label',  align: 'left'},
        { name: 'secDestnDpt', type: 'label',  align: 'left'},
        { name: 'cstBrd', type: 'label',  align: 'left'},
        { name: 'bfSecAfiDptCd', type: 'label',  align: 'left'},
        { name: 'bfSecAfiDptName', type: 'label',  align: 'left'},
        { name: 'secAsiInfoRema', type: 'label',  align: 'left'},
        { name: 'crntSecTermSrtDate', type: 'dateLabel',  align: 'left'},
        { name: 'crntSecTermEndDate', type: 'dateLabel',  align: 'left'},
        { name: 'bfSecTermSrtDate', type: 'dateLabel',  align: 'left'},
        { name: 'bfSecTermEndDate', type: 'dateLabel',  align: 'left'},
        { name: 'lastUdr', type: 'label',  align: 'left'},
        { name: 'lastUpDate', type: 'timeLabel',  align: 'left'},
        
    ];

    /* ======== エクセルの設定 ======== */
    const excelConfig = [
        { id:'empNmb', name:'従業員番号', type:'normal'},
        { id:'empFullName', name:'氏名', type:'normal'},
        { id:'entryDate', name:'入社日(開始日)', type:'date'},
        { id:'secSrtDate', name:'出向開始日', type:'date'},
        { id:'rtnDate', name:'帰任日', type:'date'},
        { id:'secDestnCmpCd', name:'出向先_会社コード', type:'normal'},
        { id:'secDestnCmpName', name:'出向先_会社', type:'normal'},
        { id:'secDestnDpt', name:'出向先_部署', type:'normal'},
        { id:'cstBrd', name:'費用負担(TC：出向先)', type:'normal'},
        { id:'bfSecAfiDptCd', name:'出向前所属部コード', type:'normal'},
        { id:'bfSecAfiDptName', name:'出向前所属部署', type:'normal'},
        { id:'secAsiInfoRema', name:'備考', type:'normal'},
        { id:'crntSecTermSrtDate', name:'現出向期間開始日', type:'date'},
        { id:'crntSecTermEndDate', name:'現出向期間終了日', type:'date'},
        { id:'bfSecTermSrtDate', name:'前回出向期間開始日', type:'date'},
        { id:'bfSecTermEndDate', name:'前回出向期間終了日', type:'date'},
        { id:'lastUdr', name:'最終更新者', type:'normal'},
        { id:'lastUpDate', name:'最終更新日', type:'time'}
    ]

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    const searchContentsLeft = [
        {id:'sarLiteral',type:'input',name:'検索文字',placeholder:'',maxLength:50,width:'280px', pattern:'keyword'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];
    
    
    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
    {id:'excel',type:'excelButton',excelTitle:'出向社員(出)情報一覧', excelConfig:excelConfig},    
    ];
    /* ====== 検索初期値を定義 ====== */
    const defaultSearch = {
        sarLiteral:''
    }
    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */


    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
			<GetListTemp
				listType='list'
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='出向社員(出)情報一覧'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/employee/getlistassignedemployee'//一覧取得のApiPath
				headData={headData}//テーブルヘッダ設定
                defaultSearch={defaultSearch}//初期検索値
				getConfig={getConfig}//テーブル取得設定
				bodyData={bodyData}//テーブルボディ設定
                onClickBodyRow={onClickBodyRow}//行クリックの処理
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 

